/**
 * Determines if a node is a template node based on its ID.
 * Template nodes have IDs that start with "_TEMPLATE_".
 */
export function isTemplateNode(id: string): boolean {
  return id.startsWith("_TEMPLATE_");
}
